

  var sliderOpts = {
    animation: 'fade',
    animationSpeed: 500,
    pauseOnHover: true,
    keyboard: false,
    slideshow: true,
    slideshowSpeed: 3000,
    directionNav: true,
    startAt: 1
  }

  // Initialize slider on docready

  $(window).on('load', function() {

    var $slider = $('.flexslider');

    if ($slider.length) {

      if ($slider.find('li').length === 1) {
        sliderOpts.slideshow = false;
        sliderOpts.slideshowSpeed = 0;
        sliderOpts.controlNav = false;
        sliderOpts.directionNav = false;
      }

      setTimeout(function () {
        $slider.flexslider(sliderOpts).show();
        //$slider.find('li').removeClass('hidden');
      }, 2000);
    }

  });




  
  var productSliderOpts = {
    animation: 'slide',
    animationSpeed: 500,
    pauseOnHover: true,
    keyboard: false,
    slideshow: false,
    slideshowSpeed: 7000,
    itemWidth: 210,
    itemMargin: 30,
    minItems: 1,
    maxItems: 5,
    randomize: true
  }

  // Initialize slider on docready

  $(window).on('load', function() {

    var $productSlider = $('.product-slider');

    if ($productSlider.length) {

      if ($productSlider.find('li').length === 4) {
        productSliderOpts.slideshow = false;
        productSliderOpts.slideshowSpeed = 0;
        productSliderOpts.controlNav = false;
        productSliderOpts.directionNav = false;
      }

      //setTimeout(function () {
        $productSlider.flexslider(productSliderOpts).show();
      //}, 2000);
    }

  });


